import { expVal } from '@atlassian/jira-feature-experiments';

const VIEW_ISSUE_ALIAS = 'bentoViewIssue';

const getUserQueryFragment = () => `
    user {
        key
        accountId
        emailAddress
        avatarUrl
        displayName
        active
    }
`;

const getConfluencePagesQueryFragment = () => `
    pages {
        ... on ConfluencePage {
            id
            globalId
            href
            title
            type
            lastUpdatedContext {
                ${getUserQueryFragment()}
            }
        }
        ... on FailedRemoteLink {
            id
            error
            link {
                id
                globalId
                href
            }
            repairLink { href }
        }
    }
`;

const getConfluencePageGroupQueryFragment = () => `
    pageCount
    ${getConfluencePagesQueryFragment()}
`;

export const getWebLinksFragment = (): string => `
    webLinks(allowThirdParties: true, orderBy: "-id") {
        linkCount
        links {
            id
            href
            linkText
            iconUrl
            summary
            resolved
            relationship
            applicationName
            applicationType
        }
    }
`;

const getConfluenceDataQueryFragment = () => `
    confluencePages {
        linkedPages {
            ${getConfluencePageGroupQueryFragment()}
        }
        mentionedPages {
            ${getConfluencePageGroupQueryFragment()}
        }
    }
`;

const getRemoteDataQueryFragment = () => `
    issueId
    remoteLinks {
        isLinkingEnabled
        ${
					!expVal('attachments-1p-consolidation-experiment', 'isExperimentEnabled', false)
						? getConfluenceDataQueryFragment()
						: ''
				}
        ${getWebLinksFragment()}
    }
`;

const getRemoteIssueLinksFragment = () => `
	remoteIssueLinks {
		edges {
			node {
				id
				globalId
				title
				relationship
				href
				content {
					__typename
					... on RemoteJiraIssueLinkResultSuccess {
						issueId
						key
						summary
						statusId
						statusName
						statusCategoryId
						isResolved
						issueTypeName
						issueTypeIconUrl
						priorityName
						priorityIconUrl
						assigneeDisplayName
						assigneeAvatarUrl
					}
					... on RemoteJiraIssueLinkResultError {
						errorType
						repairLink
					}
				}
			}
		}
	}
`;

const getRemoteDataQueryProjectTypeFragment = () => `
    jira {
        issueByKey(key: $issueKey, cloudId: $cloudId) {
            projectField {
                    project {
                        projectType
                }
            }
        }
    }
`;

export const getRemoteDataQueryPrefix = (): string => '_remote_data';

export const ISSUE_VIEW_REMOTE_DATA_QUERY = 'issueViewRemoteDataQuery';

export const getIssueRemoteDataQuery = (): string => `
    query ${ISSUE_VIEW_REMOTE_DATA_QUERY}($issueKey: String!) {
        ${VIEW_ISSUE_ALIAS}${getRemoteDataQueryPrefix()}: viewIssue(issueKey: $issueKey) {
        	${getRemoteIssueLinksFragment()}
            ${getRemoteDataQueryFragment()}
        }
    }
`;

export const getIssueRemoteDataQueryWithProject = (): string => `
    query ${ISSUE_VIEW_REMOTE_DATA_QUERY}($issueKey: String!, $cloudId: ID!) {
        ${getRemoteDataQueryProjectTypeFragment()}
        ${VIEW_ISSUE_ALIAS}${getRemoteDataQueryPrefix()}: viewIssue(issueKey: $issueKey) {
        	${getRemoteIssueLinksFragment()}
            ${getRemoteDataQueryFragment()}
        }
    }
`;
